import { walkInfoLocationsForComponent } from '../../Digital3DView';

/**
 * Flatten nested machine info components/locations into a simple list for the sidebar.
 */
export function collectSensorsFromMachineInfo(details) {
  const rows = [];
  if (!details || !details.components) return rows;

  const visitLocations = (component, locations) => {
    if (!locations) return;
    locations.forEach((loc) => {
      const tag = loc.tag || loc.tag_info || loc.tag_details;
      rows.push({
        id: loc.id,
        name: loc.name || loc.location_type_name || loc.display_name || 'Location',
        tagLabel: tag && (tag.name || tag.serial_number || tag.serial),
        condition: loc.condition != null ? loc.condition : component.condition,
      });
    });
  };

  const walk = (components) => {
    if (!components) return;
    components.forEach((c) => {
      // A component's monitored points live under BOTH `locations` and
      // `bearings`, and `bearings` arrives either as an array or as an object
      // keyed by position. Only `locations` was read here, so bearing-mounted
      // sensors — most of the sensors on a real machine — were missing from the
      // sidebar while the 3D scene showed them. walkInfoLocationsForComponent
      // already handles all three shapes; reuse it rather than re-deriving.
      const seen = [];
      walkInfoLocationsForComponent(c, loc => seen.push(loc));
      visitLocations(c, seen);
      walk(c.components);
    });
  };

  walk(details.components);
  return rows;
}
